const DEFAULT_API_URL = 'http://localhost:8080'

const env = {
  API_URL: process.env.REACT_APP_API_URL?.trim() || DEFAULT_API_URL,
}

export default env
